/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button, Flex } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';


const OnClick = (event, dispatch, boardID, colonyID) =>
{
  dispatch.pushForeground({ route: Routes.DashboardAttach.replace(':id', boardID).replace(':colony', colonyID) });
};


export default ({ board, colony }) =>
{
  const dispatch = use(Navigation.Dispatch);

  const onClick = useCallback(OnClick, [ dispatch, board.cass.id, colony.cass.id ]);

  return (
    <Flex justify = 'end'>
      <Button onClick = {onClick}>Attack</Button>
    </Flex>
  );
};
